import EmailAttachment, {
    documentMimeTypes,
} from "@/domain/entities/emails/EmailAttachement";
import { File } from "lucide-react";
import { ReactNode } from "react";
import docIcons from "../../docIcons";

const getAttachmentIcon = (
    attachment: EmailAttachment,
    className = "mr-2 max-h-6 max-w-6 text-surface-invert",
): ReactNode => {
    const Icon = docIcons[attachment.type as documentMimeTypes] || File;

    return typeof Icon === "string" ? (
        <img alt="" className={className} src={Icon} />
    ) : (
        <Icon className={className} />
    );
};

export default getAttachmentIcon;
